import gql from 'graphql-tag';

import conversationUserPromptFragment from '../fragments/conversationUserPromptFragment';

export const mutationUpdateConversationUserPrompt = gql`
  mutation updateConversationUserPrompt(
    $id: DokkioID!
    $userRating: Int
    $userRatingReason: String
  ) {
    updateConversationUserPrompt(
      id: $id
      userRating: $userRating
      userRatingReason: $userRatingReason
    ) {
      ...conversationUserPromptFragment
    }
  }
  ${conversationUserPromptFragment}
`;
export default mutationUpdateConversationUserPrompt;
